import client from '../api/client.js'

export const fetchSMTPSettings = async () => {
  const response = await client.get('/admin/smtp')
  return response?.data
}

export const updateSMTPSettings = async (payload) => {
  const response = await client.put('/admin/smtp', payload)
  return response?.data
}

export const sendSMTPTestEmail = async (recipientEmail) => {
  const response = await client.post('/admin/smtp/test', { recipient_email: recipientEmail })
  return response?.data
}

